const $ = jQuery.noConflict();
let autocomplete;
let address1Field;
// let address2Field;
let postalField;
let iframeForm;
'use strict';
const LocationAutocomplete = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	initAutocomplete(el) {
		iframeForm = el;
		if (!el) {
			iframeForm = document.querySelector('.js-hubspot-form');
		}
		if (!iframeForm) {
			return false;
		}
		address1Field = iframeForm.querySelector('input[name="address"]');
		if (!address1Field) {
			return false;
		}
		// address2Field = document.querySelector('#address2');
		postalField = iframeForm.querySelector('input[name="zip"]');
		// Create the autocomplete object, restricting the search predictions to
		// addresses in the US and Canada.
		// eslint-disable-next-line no-undef
		autocomplete = new google.maps.places.Autocomplete(address1Field, {
			componentRestrictions: {country: ['us', 'ca']},
			fields: ['address_components', 'geometry'],
			types: ['address'],
		});
		address1Field.focus();
		// When the user selects an address from the drop-down, populate the
		// address fields in the form.
		autocomplete.addListener('place_changed', LocationAutocomplete.fillInAddress);
	},

	fillInAddress() {
		// Get the place details from the autocomplete object.
		const place = autocomplete.getPlace();
		let address1 = '';
		let postcode = '';
		// args: string type, boolean bubbles, boolean cancelable
		// Get each component of the address from the place details,
		// and then fill-in the corresponding field on the form.
		// place.address_components are google.maps.GeocoderAddressComponent objects
		// which are documented at http://goo.gle/3l5i5Mr
		for (const component of place.address_components) {
			const componentType = component.types[0];
			const realCity = iframeForm.querySelector('input[name="city"]');
			const realState = iframeForm.querySelector('input[name="state"]');
			// eslint-disable-next-line default-case
			switch (componentType) {
				case 'street_number': {
					address1 = `${component.long_name} ${address1}`;
					break;
				}

				case 'route': {
					address1 += component.short_name;
					break;
				}

				case 'postal_code': {
					postcode = `${component.long_name}${postcode}`;
					break;
				}

				case 'postal_code_suffix': {
					postcode = `${postcode}-${component.long_name}`;
					break;
				}
				case 'locality':
					document.querySelector('.js-hubspot-form input[name="city"]').value = component.long_name;
					realCity.value = component.long_name;
					$(realCity).trigger('change');
					break;
				case 'administrative_area_level_1': {
					document.querySelector('.js-hubspot-form input[name="state"]').value = component.short_name;
					realState.value = component.short_name;
					$(realState).trigger('change');
					break;
				}
				case 'country':
					// document.querySelector('#country').value = component.long_name;
					break;
			}
		}

		address1Field.value = address1;
		const address1FieldReal = iframeForm.querySelector('input[name="address"]');
		address1FieldReal.value = address1;
		postalField.value = postcode;
		const realPostcode = iframeForm.querySelector('input[name="zip"]');
		realPostcode.value = postcode;
		// After filling the form with address components from the Autocomplete
		// prediction, set cursor focus on the second address line to encourage
		// entry of subpremise information such as apartment, unit, or floor number.
		// address2Field.focus();
	}

};

export default LocationAutocomplete;
